"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _formatDecimal=_interopRequireDefault(require("./format-decimal"));var exponent=function exponent(_x){var x=(0,_formatDecimal.default)(Math.abs(_x));return x?x[1]:NaN};var _default=exponent;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/exponent.js
// module id = mDFj
// module chunks = 5